import { initContract } from "@ts-rest/core";
import {
	CreateProfileDtos,
	findProfileQuery,
	PaginatedCreatedProfile,
	updateProfileInput,
} from "../validators/profile.validators";
import { createStaffInput } from "../validators/profile.validators";
import { z } from "zod";

const c = initContract();

export const profileContract = c.router({
	getUsersProfile: {
		method: "GET",
		path: "/profile",
		query: findProfileQuery,
		responses: {
			200: c.type<PaginatedCreatedProfile>(),
		},
	},
	getAuthProfile: {
		method: "GET",
		path: "/profile/:profileId",
		responses: {
			200: c.type<CreateProfileDtos>(),
		},
	},
	updateUserProfile: {
		method: "PUT",
		path: "/profile/:profileId",
		body: updateProfileInput,
		responses: {
			200: c.type<CreateProfileDtos>(),
		},
	},
	createUserProfile: {
		method: "POST",
		path: "/profile",
		body: createStaffInput,
		responses: {
			200: c.type<CreateProfileDtos>(),
		},
	},
	resendInvite: {
		method: "POST",
		path: "/profile/:profileId/resend-invite",
		body: z.void(),
		responses: {
			204: c.type<void>(),
		},
	},
});
